import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "default-info"
};
import { ref, onMounted, computed } from 'vue';
import { getModelName } from '@views/main/config';
export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultInfo',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const info = ref({
      selectionModel: [],
      websiteInfo: ''
    });
    const modelHtml = computed(() => {
      const arr = [];
      info.value.selectionModel.forEach(x => {
        const modelItem = getModelName(x);
        if (modelItem) arr.push(`【${modelItem.label}】`);
      });
      return arr.join('、') || '';
    });
    onMounted(() => {
      try {
        info.value = JSON.parse(props.content.text);
      } catch (error) {
        info.value = {
          selectionModel: []
        };
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, "AI大模型：" + _toDisplayString(modelHtml.value), 1), _createElementVNode("div", null, "官网信息：官网 " + _toDisplayString(info.value.websiteInfo), 1)]);
    };
  }
});